import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lns-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
